import { BaseFloorplanViewElement2D } from "./BaseFloorplanViewElement2D";
import { Vector2 } from 'three';
import { Point } from 'pixi.js';
import { Dimensioning } from '../../core/dimensioning.js';
import { EVENT_UPDATED } from '../../core/events.js';


export class FloorItemView2D extends BaseFloorplanViewElement2D{
    constructor(floorplan, options, item, viewer3D){
        super(floorplan, options);
        this.item=item;
        this.viewer3D = viewer3D;

        // draw the item
        this.update();
    }

    __dragMove(evt){
        super.__dragMove(evt);
        // move only if dragging
        if(this.__isDragging){
            // mouse position in canvas coordinates
            let mouseCoordinates = evt.data.getLocalPosition(this.parent);
            let mCanvasCoordinates = Dimensioning.pixelToCmVector2D(mouseCoordinates);
            // I have absolutely no idea why it is needed to multply the coordinates by 4,
            // but it does work, even when zooming or moving around
            mCanvasCoordinates.x = mCanvasCoordinates.x*4;
            mCanvasCoordinates.y = mCanvasCoordinates.y*4;
            this.item.__position.x = mCanvasCoordinates.x;
            this.item.__position.z = mCanvasCoordinates.y;

            // updating the posiiton of the physical 3D item
            this.item.dispatchEvent({type: EVENT_UPDATED, item:this, property:'position'});
            // updating the viewer3D
            this.viewer3D.needsUpdate = true;
            this.update();
        }
    }

    update(){
        this.clear();
        this.lineStyle(0, 0xF0F0F0);
        let position = new Vector2(this.item.__position.x, this.item.__position.z);
        let widthItem = this.item.halfSize.x;
        let depthItem = this.item.halfSize.z;

        let a = position.clone().add(new Vector2(widthItem, depthItem));
        let b = position.clone().add(new Vector2(widthItem, -depthItem));
        let c = position.clone().add(new Vector2(-widthItem, -depthItem));
        let d = position.clone().add(new Vector2(-widthItem, depthItem));

        let points = [
            new Point(Dimensioning.cmToPixel(a.x), Dimensioning.cmToPixel(a.y)),
            new Point(Dimensioning.cmToPixel(b.x), Dimensioning.cmToPixel(b.y)),
            new Point(Dimensioning.cmToPixel(c.x), Dimensioning.cmToPixel(c.y)),
            new Point(Dimensioning.cmToPixel(d.x), Dimensioning.cmToPixel(d.y)),
        ];

        this.beginFill(0xFF007F, 0.80);
        this.drawPolygon(points);
        this.endFill();
    }
}